import { render, staticRenderFns } from "./month_notes.vue?vue&type=template&id=2ab56ded&scoped=true&"
import script from "./month_notes.vue?vue&type=script&lang=js&"
export * from "./month_notes.vue?vue&type=script&lang=js&"
import style0 from "./month_notes.vue?vue&type=style&index=0&id=2ab56ded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab56ded",
  null
  
)

export default component.exports